<template>
		<section class="section clearfix">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12 align-center">
						<i class="fa fa-binoculars fa-3x mar-bot20 notransition animated fadeInLeftNow animation103"></i>
						<p class="section-header notransition animated fadeInDownNow animation103">生命不息，奋斗不止</p>
						<!--<p class="section-subheader notransition animated fadeInUpNow animation103">信仰之跃</p>-->
					</div>
				</div>
				<div class="row pad-bot40">
					<div class="mainp col-md-6 align-center notransition animated fadeInLeftBigNow animation103 mar-top40">
						<p>努力的意义不是为了无懈可击，万里挑一的自己</p>
						<h3>而是为了告诉你能够成为一个什么样的自己</h3>
						<br>
						<p>我会成为火影</p>
						<h3>而且是超越历代的火影！</h3>
					</div>
					<div class="col-md-6 notransition animated fadeInRightNow animation203">
						<img src="../assets/img/side/huoy.png" class="img-responsive center-block">
					</div>
				</div>
				<div class="row bg-gray pad-bot40 pad-top40">
					<div class="col-md-6 notransition animated fadeInLeftNow animation203">
						<img src="../assets/img/side/suolo.png" class="img-responsive center-block pad-bot10">
					</div>
					<div class="mainp col-md-6 align-center notransition animated fadeInRightBigNow animation103 mar-top80">
						<h3>我发誓</h3>
						<p>在打倒那个男人以前，我绝对不会再输给任何人</p>
						<br>
						<h3>你有什么不满意吗？</h3>
						<br>
						<h3>海贼王 ！！！</h3>
					</div>
				</div>
				<div class="row pad-bot40 pad-top40">
					<div class="mainp col-md-6 align-center notransition animated fadeInLeftBigNow animation103 mar-top100">
						<h3>所谓英雄</h3>
						<p>就是即便豁出性命</p>
						<h3>也要去实现那些漂亮话的职业啊</h3>
						<br>
						<br>
						<h3>这不是很温柔的个性吗？</h3>
            </div>
            <div class="col-md-6 notransition animated fadeInRightNow animation203">
                <img src="../assets/img/side/lvg.png" class="img-responsive center-block">
            </div>
        </div>
    </div>
</section>

</template>

<style>

</style>

<script>
export default {
  name: 'CaseContent'
}
</script>